import Search from "../components/search/Index.vue";
import NavBar from "../components/navBar/Index.vue";
import Carousel from "../components/carousel/Index.vue";
import Coupon from "../components/coupon/Index.vue";
import ProductCatelogue from "../components/productCatalogue/Index.vue";
import Products from "../components/products/Index.vue";
import tool from "@/utils/tool.js";
import event from "@/event/index.js";
event.$on("scrrolToTarget", e => {
  gotoTarget(e.type, e.id);
});
const gotoTarget = function(type, id) {
  console.log("22322");
  let idName = "";
  switch (type) {
    case "search":
      idName = "new-search-id";
      break;
    case "navbar":
      idName = "new-navbar-id-" + id;
      break;
    case "carousel":
      idName = "new-carousel-id-" + id;
      break;
    case "coupon":
      idName = "new-coupon-id-" + id;
      break;
    case "productCatelogue":
      idName = "new-productCatelogue-id-" + id;
      break;
    case "products":
      idName = "new-products-id-" + id;
      break;
  }
  const targetSection = document.getElementById(idName);
  const parentNode = document.getElementById("scrollContainer");
  if (targetSection && parentNode) {
    // targetSection.scrollIntoView({ behavior: "smooth", block: "center" });
    scrollToWithOffset(targetSection, 100, parentNode);
  }
};
export const scrollToWithOffset = (element, offset = 10, container = window) => {
  if (container === window) {
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  } else {
    const elementPosition = element.offsetTop;
    const offsetPosition = elementPosition - offset;
    container.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
};
// 单独导出pageSortRender方法
export const pageSortRender = (h, list, userInfo) => {
  // 同样的实现，但是注意这里不能使用this，所以需要调整组件的使用方式
  // 因为组件不是通过this.$options.components来解析，而是需要直接使用组件选项
  // 我们可以将组件作为参数传入，或者在这里直接使用导入的组件
  const components = {
    Search,
    NavBar,
    Carousel,
    Coupon,
    ProductCatelogue,
    Products
  };

  const renderList = list.map(e => {
    if (e.moduleName === "搜索") {
      return <components.Search id="new-search-id"></components.Search>;
    }
    if (e.moduleName === "导航" && e.children && e.children.length > 0) {
      return <components.NavBar modelName={e.moduleName} list={e.children || []} id={e.id}></components.NavBar>;
    }
    if (e.moduleName === "广告图片" && e.content && e.content.length > 0) {
      return (
        <div class="page-width">
          <div id={"new-carousel-id-" + e.id}></div>
          <div class="config-nav-name" data-type="carousel" data-id={e.id} style="display:none">
            广告图片
          </div>
          <components.Carousel showUserInfo={!!e.showUserInfo} list={e.content || []}></components.Carousel>
        </div>
      );
    }
    if (e.moduleName === "优惠券" && userInfo && userInfo.userId) {
      return (
        <div class="page-width">
          <div id={"new-coupon-id-" + e.id}></div>
          <components.Coupon id={e.id} title={e.title}></components.Coupon>
        </div>
      );
    }
    if (e.moduleName === "商品目录" && e.areas && e.areas.length > 0) {
      return (
        <div class="page-width">
          <div id={"new-productCatelogue-id-" + e.id}></div>
          <components.ProductCatelogue
            layout={e.layout}
            list={e.areas || []}
            setting={e.setting}
            title={e.title}
            id={e.id}
          ></components.ProductCatelogue>
        </div>
      );
    }
    if (e.moduleName === "商品区") {
      return (
        <div class="page-width">
          <div id={"new-products-id-" + e.id}></div>
          <components.Products id={e.id} info={e}></components.Products>
        </div>
      );
    }
  });
  return renderList;
};
//商品命名规则
export const getGoodsName = (rules, goods) => {
  if (rules && rules.length > 0) {
    let nameStr = "";
    rules.map(item => {
      if (goods[item.content]) {
        nameStr += goods[item.content] + " ";
      }
    });
    return nameStr;
  }
  return `${goods.name} ${goods.code} ${goods.brand} ${goods.property} ${goods.vehModel} ${goods.category}`;
};
//判断元素是否出现在视窗中
export const observeElementVisibility = function(el, callback) {
  const options = {
    root: null, // 相对于视口
    rootMargin: "0px",
    threshold: 0.1 // 当10%的元素可见时触发
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      callback(entry.isIntersecting, entry.intersectionRatio);
    });
  }, options);

  observer.observe(el);

  return observer; // 返回observer以便后续取消监听
};
/**
 * 提取 XML 标签内的所有内容（原样保留，不添加任何额外字符）
 * @param {string} xmlString - 包含 XML 标签的字符串
 * @returns {string} 标签内的内容，按出现顺序拼接
 */
// export function extractTagContent(xmlString) {
//   // 匹配成对标签 <Tag>content</Tag> 和自闭合标签 <Tag/>
//   return xmlString.replace(/<(\w+)>([^<]*)<\/\1>/g, '<span class="$1">$2</span>');
// }
// export function extractTagContent(xmlString) {
//   let result = xmlString;

//   // 处理成对标签 <Tag>content</Tag>
//   result = result.replace(/<(\w+)>([^<]*)<\/\1>/g, (match, tagName, content) => {
//     if (/price/i.test(tagName)) {
//       return `<price-show>${content}</price-show>`;
//     }
//     return `<span class="${tagName}">${content}</span>`;
//   });

//   // 处理自闭合标签 <Tag/>
//   result = result.replace(/<(\w+)\/>/g, (match, tagName) => {
//     if (/price/i.test(tagName)) {
//       return `<price-show></price-show>`;
//     }
//     return `<span class="${tagName}"></span>`;
//   });

//   return result;
// }
export function extractTagContent(xmlString) {
  if (!xmlString) return "";

  // 辅助函数：格式化单个价格
  function formatSinglePrice(priceStr) {
    if (!priceStr) return "";
    // 移除货币符号和前后空格
    const cleanPrice = priceStr.replace(/[¥$€￥]/g, "").trim();
    const parts = cleanPrice.split(".");
    let result = "";
    result += '<span class="price-icon">￥</span>';
    result += `<span class="price-integer">${parts[0]}</span>`;
    if (parts.length > 1) {
      result += `<span class="price-decimal">.${parts[1]}</span>`;
    } else {
      result += '<span class="price-decimal">.00</span>';
    }
    return result;
  }

  // 辅助函数：格式化价格（支持区间、起等）
  function formatPrice(price) {
    if (!price) return "";

    // 处理价格区间
    if (price.includes("~")) {
      const [minPrice, maxPrice] = price.split("~");
      // 清理空格和货币符号
      const minClean = minPrice.replace(/[¥$€￥]/g, "").trim();
      const maxClean = maxPrice.replace(/[¥$€￥]/g, "").trim();
      const minParts = formatSinglePrice(minClean);
      const maxParts = formatSinglePrice(maxClean);
      return `${minParts}<span class="price-separator"> ~ </span>${maxParts}`;
    }

    // 处理"起"字价格
    if (price.includes("起")) {
      const [pricePart] = price.split("起");
      const cleanPart = pricePart.replace(/[¥$€￥]/g, "").trim();
      const priceParts = formatSinglePrice(cleanPart);
      return `${priceParts}<span class="price-suffix">起</span>`;
    }

    // 处理普通数字价格
    const cleanPrice = price.replace(/[¥$€￥]/g, "").trim();
    if (!isNaN(Number(cleanPrice)) && cleanPrice.trim() !== "") {
      return formatSinglePrice(cleanPrice);
    }

    // 如果都不是，返回原内容
    return price;
  }

  // 匹配成对标签 <Tag>content</Tag>
  return xmlString.replace(/<(\w+)>([^<]*)<\/\1>/g, (match, tagName, content) => {
    // 如果标签名包含 price 或 Price（不区分大小写），使用价格格式化
    if (/price/i.test(tagName)) {
      const formattedPrice = formatPrice(content);
      if (tagName.includes("linePrice")) {
        return `<span class="price-wrapper line-price">${formattedPrice}</span>`;
      }
      return `<span class="price-wrapper">${formattedPrice}</span>`;
    }
    // 普通字段直接返回 span
    return `<span class="${tagName}">${content}</span>`;
  });
}
export function byTxtGetTitle(str) {
  if (str.includes(":")) {
    return str.split(":")[0];
  }
  return "";
}
export function byTxtGetValue(str) {
  if (str.includes(":")) {
    return str.split(":")[1];
  }
  return str;
}
